export default __webpack_public_path__ + "static/media/img-11.9258438c.jpg";